import React from 'react';
import { SmartphoneIcon, TabletIcon, MonitorIcon, PrinterIcon } from 'lucide-react';
import { Section } from './Shared';
const items = [{
  icon: SmartphoneIcon,
  label: 'Smartphone'
}, {
  icon: TabletIcon,
  label: 'Tablet'
}, {
  icon: MonitorIcon,
  label: 'Computer'
}, {
  icon: PrinterIcon,
  label: 'Printed professional binder'
}];
export const DigitalAccess = () => <Section className="max-w-4xl" data-id="element-42" data-mp="walqodl3jx4i">
    <div className="paper-panel rounded-3xl p-6 text-center md:p-10" data-id="element-43" data-mp="wbwtaa2t2yu1">
      <h2 className="mx-auto max-w-2xl font-serif text-2xl font-semibold leading-tight text-brand-burgundy md:text-4xl" data-id="element-44" data-mp="rc26ahm5ite9">
        Your Complete Qigong Library, Available Anywhere
      </h2>

      <ul className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-45" data-mp="10cgtxnml8kkx">
        {items.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex flex-col items-center gap-3 rounded-xl border border-brand-goldDark/15 bg-brand-surface/60 px-3 py-5" data-id="element-46" data-mp="2gq75tgjy8d54">
            <Icon className="h-6 w-6 text-brand-goldDark" strokeWidth={1.4} aria-hidden="true" data-id="element-47" data-mp="37u6ekcbsg0gv" />
            <span className="text-[13px] font-medium leading-snug text-brand-text md:text-sm" data-id="element-48" data-mp="3bu6u60amihpi">
              {label}
            </span>
          </li>)}
      </ul>

      <p className="mx-auto mt-8 max-w-xl text-sm text-brand-text md:text-base" data-id="element-49" data-mp="3lu7hdxbm5hyz">
        You will receive the complete collection by email immediately after your
        purchase. Download it once and consult it whenever you need it.
      </p>
    </div>
  </Section>;